.root {
  display: flex;
  flex-direction: column;
}

.formLabel {
  margin: 16px;
  margin-bottom: 8px;
}

.sliderPadding {
  padding-left: 16px;
  padding-right: 16px;
}

.helpText {
  margin-bottom: 32px;
}

.optionGridFlex {
  display: flex;
}

.optionTextField {
  margin-top: 8px;
  flex: 1;
}

.createButton {
  margin: 16px;
}
